__turbopack_context__.v({
  "contactInfoBlockEmail": "styles-module-scss-module__bugTGa__contactInfoBlockEmail",
  "contactInfoBlockPhoneNumber": "styles-module-scss-module__bugTGa__contactInfoBlockPhoneNumber",
  "contactInfoBlockWorkTime": "styles-module-scss-module__bugTGa__contactInfoBlockWorkTime",
  "contactsChatLink": "styles-module-scss-module__bugTGa__contactsChatLink",
  "contactsTitle": "styles-module-scss-module__bugTGa__contactsTitle",
  "contactsTopPanel": "styles-module-scss-module__bugTGa__contactsTopPanel",
});
